<template>
  <transition name="fade" appear>
    <div
      v-hover-scale-mouse
      data-apollo-hover
      class="sound"
      :class="{ 'sound--menu-open': menuIsOpen }"
      @click="toggleAudio()">
      <canvas ref="canvas"/>
    </div>
  </transition>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import anime from 'animejs';
import AudioLine from '@/scripts/AudioLine';
import engine from '@/scripts/engine';

export default {
  name: 'SoundButton',
  data() {
    return {
      audioPlay: true,
      line: null,
    };
  },
  computed: {
    ...mapState([
      'sound',
      'menuIsOpen',
    ]),
  },
  mounted() {
    this.initLine();
  },
  methods: {
    ...mapMutations(['toggleMute']),
    toggleAudio() {
      this.audioPlay = !this.audioPlay;
      this.toggleMute();

      if (this.audioPlay) {
        this.sound.play();
        this.sound.fade(0, 0.3, 1000);
        anime({
          targets: this.line,
          duration: 1300,
          speed: 1,
        });
      } else {
        this.sound.fade(0.3, 0, 1000);
        anime({
          targets: this.line,
          duration: 1300,
          speed: 0,
        });
      }
    },

    initLine() {
      this.line = new AudioLine(this.$refs.canvas);
      this.line.init();

      engine.add(this.render, 'audioLine-render');
    },

    render() {
      this.line.render();
    },
  },
};
</script>

<style lang="scss" scoped>
.sound {
  opacity: 0;
  visibility: hidden;

  box-sizing: content-box;
  overflow: hidden;
  padding: 1rem;
  width: 2.35vw;
  min-width: 46px;

cursor: pointer;

  transform: translateX(1rem) translateY(50%);
  transition: opacity 2s 2s cubic-bezier(0.165, 0.84, 0.44, 1);

  @include mq(mobileL) {
    visibility: visible;
    opacity: 1;
  }

  &--menu-open {
    visibility: visible;
    opacity: 1;
  }
}

/* animation */
.fade-in {
  &-enter-active {
    transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  }

  &-enter {
    opacity: 0;
  }
}
</style>
